import request from './request';
import HangHoaModel from '../models/hang_hoa';

type GetAllHangHoasResponse = {
  success: boolean;
  hang_hoas?: HangHoaModel[];
  hangHoas?: HangHoaModel[];
  data?: HangHoaModel[];
  message?: string;
};

const getHangHoas = (
  result: GetAllHangHoasResponse,
  errorMessage = 'Không thể tải danh sách hàng hóa'
): HangHoaModel[] => {
  if (!result.success) {
    throw new Error(result.message || errorMessage);
  }

  return Array.isArray(result.hang_hoas)
    ? result.hang_hoas
    : Array.isArray(result.hangHoas)
      ? result.hangHoas
      : Array.isArray(result.data)
        ? result.data
        : [];
};

const hangHoaService = {
  userSaleGetAllHangHoa: async (): Promise<HangHoaModel[]> => {
    const response = await request.get<GetAllHangHoasResponse>(
      'user-sale-get-all-hang-hoa'
    );
    return getHangHoas(response.data);
  },
  getDanhSachMonAnChoBep: async (): Promise<HangHoaModel[]> => {
    const response = await request.get<GetAllHangHoasResponse>(
      'user-sale-get-danh-sach-mon-an-cho-bep'
    );
    return getHangHoas(response.data, 'Không thể tải danh sách món ăn của bếp');
  },
};

export default hangHoaService;